import _ from 'lodash';

function portsFlat(ports, destination) {
    ports = _.cloneDeep(ports);
    return ports.forEach((item) => {
        if (item.length > 1) {
            item.oneOf.forEach((prt) => {
                destination.push({
                    port: prt,
                    sign: 'or',
                });
            });
        } else {
            destination.push({
                port: item.oneOf[0],
                sign: 'and',
            });
        }
    });
}

function portsTree(ports, destination) {
    ports = _.cloneDeep(ports);
    return ports.forEach((item) => {
        if (item.sign === 'and') {
            destination.push({ oneOf: [item.port] });
        } else {
            destination[destination.length - 1].oneOf.push(item.port);
        }
    });
}

export {
    portsFlat,
    portsTree,
};



// WEBPACK FOOTER //
// ./app/helpers/cargoUtils.js